import request from '@/utils/analyticsRequest'

export function listConversationMessages(contactId, params = {}) {
  return request({
    url: `/api/v1/ghl/ai/conversations/${encodeURIComponent(contactId)}/messages`,
    method: 'get',
    params
  })
}

export function markConversationRead(contactId) {
  return request({
    url: `/api/v1/ghl/ai/conversations/${encodeURIComponent(contactId)}/read`,
    method: 'post'
  })
}

export function sendConversationMessage(contactId, payload) {
  const body = typeof payload === 'string'
    ? { message: payload }
    : payload;

  return request({
    url: `/api/v1/ghl/ai/conversations/${encodeURIComponent(contactId)}/messages`,
    method: 'post',
    data: body,
    headers: { 'Content-Type': 'application/json' }
  })
}
